var tslib_1 = require("tslib");
// https://d3js.org/d3-array/ v2.11.0 Copyright 2021 Mike Bostock
(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
        typeof define === 'function' && define.amd ? define(['exports'], factory) :
            (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.d3 = global.d3 || {}));
}(this, (function (exports) {
    'use strict';
    function ascending(a, b) {
        return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
    }
    function bisector(f) {
        var delta = f;
        var compare = f;
        if (f.length === 1) {
            delta = function (d, x) { return f(d) - x; };
            compare = ascendingComparator(f);
        }
        function left(a, x, lo, hi) {
            if (lo == null)
                lo = 0;
            if (hi == null)
                hi = a.length;
            while (lo < hi) {
                var mid = (lo + hi) >>> 1;
                if (compare(a[mid], x) < 0)
                    lo = mid + 1;
                else
                    hi = mid;
            }
            return lo;
        }
        function right(a, x, lo, hi) {
            if (lo == null)
                lo = 0;
            if (hi == null)
                hi = a.length;
            while (lo < hi) {
                var mid = (lo + hi) >>> 1;
                if (compare(a[mid], x) > 0)
                    hi = mid;
                else
                    lo = mid + 1;
            }
            return lo;
        }
        function center(a, x, lo, hi) {
            if (lo == null)
                lo = 0;
            if (hi == null)
                hi = a.length;
            var i = left(a, x, lo, hi - 1);
            return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
        }
        return { left: left, center: center, right: right };
    }
    function ascendingComparator(f) {
        return function (d, x) { return ascending(f(d), x); };
    }
    function number(x) {
        return x === null ? NaN : +x;
    }
    function numbers(values, valueof) {
        var values_1, values_1_1, value, e_1_1, index_1, values_2, values_2_1, value, e_2_1;
        var e_1, _a, e_2, _b;
        return tslib_1.__generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!(valueof === undefined)) return [3 /*break*/, 9];
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 6, 7, 8]);
                    values_1 = tslib_1.__values(values), values_1_1 = values_1.next();
                    _c.label = 2;
                case 2:
                    if (!!values_1_1.done) return [3 /*break*/, 5];
                    value = values_1_1.value;
                    if (!(value != null && (value = +value) >= value)) return [3 /*break*/, 4];
                    return [4 /*yield*/, value];
                case 3:
                    _c.sent();
                    _c.label = 4;
                case 4:
                    values_1_1 = values_1.next();
                    return [3 /*break*/, 2];
                case 5: return [3 /*break*/, 8];
                case 6:
                    e_1_1 = _c.sent();
                    e_1 = { error: e_1_1 };
                    return [3 /*break*/, 8];
                case 7:
                    try {
                        if (values_1_1 && !values_1_1.done && (_a = values_1.return)) _a.call(values_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                    return [7 /*endfinally*/];
                case 8: return [3 /*break*/, 17];
                case 9:
                    index_1 = -1;
                    _c.label = 10;
                case 10:
                    _c.trys.push([10, 15, 16, 17]);
                    values_2 = tslib_1.__values(values), values_2_1 = values_2.next();
                    _c.label = 11;
                case 11:
                    if (!!values_2_1.done) return [3 /*break*/, 14];
                    value = values_2_1.value;
                    if (!((value = valueof(value, ++index_1, values)) != null && (value = +value) >= value)) return [3 /*break*/, 13];
                    return [4 /*yield*/, value];
                case 12:
                    _c.sent();
                    _c.label = 13;
                case 13:
                    values_2_1 = values_2.next();
                    return [3 /*break*/, 11];
                case 14: return [3 /*break*/, 17];
                case 15:
                    e_2_1 = _c.sent();
                    e_2 = { error: e_2_1 };
                    return [3 /*break*/, 17];
                case 16:
                    try {
                        if (values_2_1 && !values_2_1.done && (_b = values_2.return)) _b.call(values_2);
                    }
                    finally { if (e_2) throw e_2.error; }
                    return [7 /*endfinally*/];
                case 17: return [2 /*return*/];
            }
        });
    }
    var ascendingBisect = bisector(ascending);
    var bisectRight = ascendingBisect.right;
    var bisectLeft = ascendingBisect.left;
    var bisectCenter = bisector(number).center;
    function count(values, valueof) {
        var e_3, _a, e_4, _b;
        var count = 0;
        if (valueof === undefined) {
            try {
                for (var values_3 = tslib_1.__values(values), values_3_1 = values_3.next(); !values_3_1.done; values_3_1 = values_3.next()) {
                    var value = values_3_1.value;
                    if (value != null && (value = +value) >= value) {
                        ++count;
                    }
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (values_3_1 && !values_3_1.done && (_a = values_3.return)) _a.call(values_3);
                }
                finally { if (e_3) throw e_3.error; }
            }
        }
        else {
            var index_2 = -1;
            try {
                for (var values_4 = tslib_1.__values(values), values_4_1 = values_4.next(); !values_4_1.done; values_4_1 = values_4.next()) {
                    var value = values_4_1.value;
                    if ((value = valueof(value, ++index_2, values)) != null && (value = +value) >= value) {
                        ++count;
                    }
                }
            }
            catch (e_4_1) { e_4 = { error: e_4_1 }; }
            finally {
                try {
                    if (values_4_1 && !values_4_1.done && (_b = values_4.return)) _b.call(values_4);
                }
                finally { if (e_4) throw e_4.error; }
            }
        }
        return count;
    }
    function length(array) {
        return array.length | 0;
    }
    function empty(length) {
        return !(length > 0);
    }
    function arrayify(values) {
        return typeof values !== "object" || "length" in values ? values : Array.from(values);
    }
    function reducer(reduce) {
        return function (values) { return reduce.apply(void 0, tslib_1.__spread(values)); };
    }
    function cross() {
        var values = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            values[_i] = arguments[_i];
        }
        var reduce = typeof values[values.length - 1] === "function" && reducer(values.pop());
        values = values.map(arrayify);
        var lengths = values.map(length);
        var j = values.length - 1;
        var index = new Array(j + 1).fill(0);
        var product = [];
        if (j < 0 || lengths.some(empty))
            return product;
        while (true) {
            product.push(index.map(function (j, i) { return values[i][j]; }));
            var i = j;
            while (++index[i] === lengths[i]) {
                if (i === 0)
                    return reduce ? product.map(reduce) : product;
                index[i--] = 0;
            }
        }
    }
    function cumsum(values, valueof) {
        var sum = 0, index = 0;
        return Float64Array.from(values, valueof === undefined
            ? function (v) { return (sum += +v || 0); }
            : function (v) { return (sum += +valueof(v, index++, values) || 0); });
    }
    function descending(a, b) {
        return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
    }
    function variance(values, valueof) {
        var e_5, _a, e_6, _b;
        var count = 0;
        var delta;
        var mean = 0;
        var sum = 0;
        if (valueof === undefined) {
            try {
                for (var values_5 = tslib_1.__values(values), values_5_1 = values_5.next(); !values_5_1.done; values_5_1 = values_5.next()) {
                    var value = values_5_1.value;
                    if (value != null && (value = +value) >= value) {
                        delta = value - mean;
                        mean += delta / ++count;
                        sum += delta * (value - mean);
                    }
                }
            }
            catch (e_5_1) { e_5 = { error: e_5_1 }; }
            finally {
                try {
                    if (values_5_1 && !values_5_1.done && (_a = values_5.return)) _a.call(values_5);
                }
                finally { if (e_5) throw e_5.error; }
            }
        }
        else {
            var index_3 = -1;
            try {
                for (var values_6 = tslib_1.__values(values), values_6_1 = values_6.next(); !values_6_1.done; values_6_1 = values_6.next()) {
                    var value = values_6_1.value;
                    if ((value = valueof(value, ++index_3, values)) != null && (value = +value) >= value) {
                        delta = value - mean;
                        mean += delta / ++count;
                        sum += delta * (value - mean);
                    }
                }
            }
            catch (e_6_1) { e_6 = { error: e_6_1 }; }
            finally {
                try {
                    if (values_6_1 && !values_6_1.done && (_b = values_6.return)) _b.call(values_6);
                }
                finally { if (e_6) throw e_6.error; }
            }
        }
        if (count > 1)
            return sum / (count - 1);
    }
    function deviation(values, valueof) {
        var v = variance(values, valueof);
        return v ? Math.sqrt(v) : v;
    }
    function extent(values, valueof) {
        var e_7, _a, e_8, _b;
        var min;
        var max;
        if (valueof === undefined) {
            try {
                for (var values_7 = tslib_1.__values(values), values_7_1 = values_7.next(); !values_7_1.done; values_7_1 = values_7.next()) {
                    var value = values_7_1.value;
                    if (value != null) {
                        if (min === undefined) {
                            if (value >= value)
                                min = max = value;
                        }
                        else {
                            if (min > value)
                                min = value;
                            if (max < value)
                                max = value;
                        }
                    }
                }
            }
            catch (e_7_1) { e_7 = { error: e_7_1 }; }
            finally {
                try {
                    if (values_7_1 && !values_7_1.done && (_a = values_7.return)) _a.call(values_7);
                }
                finally { if (e_7) throw e_7.error; }
            }
        }
        else {
            var index_4 = -1;
            try {
                for (var values_8 = tslib_1.__values(values), values_8_1 = values_8.next(); !values_8_1.done; values_8_1 = values_8.next()) {
                    var value = values_8_1.value;
                    if ((value = valueof(value, ++index_4, values)) != null) {
                        if (min === undefined) {
                            if (value >= value)
                                min = max = value;
                        }
                        else {
                            if (min > value)
                                min = value;
                            if (max < value)
                                max = value;
                        }
                    }
                }
            }
            catch (e_8_1) { e_8 = { error: e_8_1 }; }
            finally {
                try {
                    if (values_8_1 && !values_8_1.done && (_b = values_8.return)) _b.call(values_8);
                }
                finally { if (e_8) throw e_8.error; }
            }
        }
        return [min, max];
    }
    // https://github.com/python/cpython/blob/a74eea238f5baba15797e2e8b570d153bc8690a7/Modules/mathmodule.c#L1423
    var Adder = /** @class */ (function () {
        function Adder() {
            this._partials = new Float64Array(32);
            this._n = 0;
        }
        Adder.prototype.add = function (x) {
            var p = this._partials;
            var i = 0;
            for (var j = 0; j < this._n && j < 32; j++) {
                var y = p[j], hi = x + y, lo = Math.abs(x) < Math.abs(y) ? x - (hi - y) : y - (hi - x);
                if (lo)
                    p[i++] = lo;
                x = hi;
            }
            p[i] = x;
            this._n = i + 1;
            return this;
        };
        Adder.prototype.valueOf = function () {
            var p = this._partials;
            var n = this._n, x, y, lo, hi = 0;
            if (n > 0) {
                hi = p[--n];
                while (n > 0) {
                    x = hi;
                    y = p[--n];
                    hi = x + y;
                    lo = y - (hi - x);
                    if (lo)
                        break;
                }
                if (n > 0 && ((lo < 0 && p[n - 1] < 0) || (lo > 0 && p[n - 1] > 0))) {
                    y = lo * 2;
                    x = hi + y;
                    if (y == x - hi)
                        hi = x;
                }
            }
            return hi;
        };
        return Adder;
    }());
    function fsum(values, valueof) {
        var e_9, _a, e_10, _b;
        var adder = new Adder();
        if (valueof === undefined) {
            try {
                for (var values_9 = tslib_1.__values(values), values_9_1 = values_9.next(); !values_9_1.done; values_9_1 = values_9.next()) {
                    var value = values_9_1.value;
                    if (value = +value) {
                        adder.add(value);
                    }
                }
            }
            catch (e_9_1) { e_9 = { error: e_9_1 }; }
            finally {
                try {
                    if (values_9_1 && !values_9_1.done && (_a = values_9.return)) _a.call(values_9);
                }
                finally { if (e_9) throw e_9.error; }
            }
        }
        else {
            var index_5 = -1;
            try {
                for (var values_10 = tslib_1.__values(values), values_10_1 = values_10.next(); !values_10_1.done; values_10_1 = values_10.next()) {
                    var value = values_10_1.value;
                    if (value = +valueof(value, ++index_5, values)) {
                        adder.add(value);
                    }
                }
            }
            catch (e_10_1) { e_10 = { error: e_10_1 }; }
            finally {
                try {
                    if (values_10_1 && !values_10_1.done && (_b = values_10.return)) _b.call(values_10);
                }
                finally { if (e_10) throw e_10.error; }
            }
        }
        return +adder;
    }
    var InternMap = /** @class */ (function (_super) {
        tslib_1.__extends(InternMap, _super);
        function InternMap(entries, key) {
            var e_11, _a;
            if (entries === void 0) { entries = []; }
            if (key === void 0) { key = keyof; }
            var _this = _super.call(this) || this;
            Object.defineProperties(_this, { _intern: { value: new Map() }, _key: { value: key } });
            try {
                for (var entries_1 = tslib_1.__values(entries), entries_1_1 = entries_1.next(); !entries_1_1.done; entries_1_1 = entries_1.next()) {
                    var _b = tslib_1.__read(entries_1_1.value, 2), key_1 = _b[0], value = _b[1];
                    _this.set(key_1, value);
                }
            }
            catch (e_11_1) { e_11 = { error: e_11_1 }; }
            finally {
                try {
                    if (entries_1_1 && !entries_1_1.done && (_a = entries_1.return)) _a.call(entries_1);
                }
                finally { if (e_11) throw e_11.error; }
            }
            return _this;
        }
        InternMap.prototype.get = function (key) {
            return _super.prototype.get.call(this, intern_get(this, key));
        };
        InternMap.prototype.has = function (key) {
            return _super.prototype.has.call(this, intern_get(this, key));
        };
        InternMap.prototype.set = function (key, value) {
            return _super.prototype.set.call(this, intern_set(this, key), value);
        };
        InternMap.prototype.delete = function (key) {
            return _super.prototype.delete.call(this, intern_delete(this, key));
        };
        return InternMap;
    }(Map));
    var InternSet = /** @class */ (function (_super) {
        tslib_1.__extends(InternSet, _super);
        function InternSet(values, key) {
            var e_12, _a;
            if (values === void 0) { values = []; }
            if (key === void 0) { key = keyof; }
            var _this = _super.call(this) || this;
            Object.defineProperties(_this, { _intern: { value: new Map() }, _key: { value: key } });
            try {
                for (var values_11 = tslib_1.__values(values), values_11_1 = values_11.next(); !values_11_1.done; values_11_1 = values_11.next()) {
                    var value = values_11_1.value;
                    _this.add(value);
                }
            }
            catch (e_12_1) { e_12 = { error: e_12_1 }; }
            finally {
                try {
                    if (values_11_1 && !values_11_1.done && (_a = values_11.return)) _a.call(values_11);
                }
                finally { if (e_12) throw e_12.error; }
            }
            return _this;
        }
        InternSet.prototype.has = function (value) {
            return _super.prototype.has.call(this, intern_get(this, value));
        };
        InternSet.prototype.add = function (value) {
            return _super.prototype.add.call(this, intern_set(this, value));
        };
        InternSet.prototype.delete = function (value) {
            return _super.prototype.delete.call(this, intern_delete(this, value));
        };
        return InternSet;
    }(Set));
    function intern_get(_a, value) {
        var _intern = _a._intern, _key = _a._key;
        var key = _key(value);
        return _intern.has(key) ? _intern.get(key) : value;
    }
    function intern_set(_a, value) {
        var _intern = _a._intern, _key = _a._key;
        var key = _key(value);
        if (_intern.has(key))
            return _intern.get(key);
        _intern.set(key, value);
        return value;
    }
    function intern_delete(_a, value) {
        var _intern = _a._intern, _key = _a._key;
        var key = _key(value);
        if (_intern.has(key)) {
            value = _intern.get(value);
            _intern.delete(key);
        }
        return value;
    }
    function keyof(value) {
        return value !== null && typeof value === "object" ? value.valueOf() : value;
    }
    function identity(x) {
        return x;
    }
    function group(values) {
        var keys = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            keys[_i - 1] = arguments[_i];
        }
        return nest(values, identity, identity, keys);
    }
    function groups(values) {
        var keys = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            keys[_i - 1] = arguments[_i];
        }
        return nest(values, Array.from, identity, keys);
    }
    function rollup(values, reduce) {
        var keys = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            keys[_i - 2] = arguments[_i];
        }
        return nest(values, identity, reduce, keys);
    }
    function rollups(values, reduce) {
        var keys = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            keys[_i - 2] = arguments[_i];
        }
        return nest(values, Array.from, reduce, keys);
    }
    function index(values) {
        var keys = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            keys[_i - 1] = arguments[_i];
        }
        return nest(values, identity, unique, keys);
    }
    function indexes(values) {
        var keys = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            keys[_i - 1] = arguments[_i];
        }
        return nest(values, Array.from, unique, keys);
    }
    function unique(values) {
        if (values.length !== 1)
            throw new Error("duplicate key");
        return values[0];
    }
    function nest(values, map, reduce, keys) {
        return (function regroup(values, i) {
            var e_13, _a, e_14, _b;
            if (i >= keys.length)
                return reduce(values);
            var groups = new InternMap();
            var keyof = keys[i++];
            var index = -1;
            try {
                for (var values_12 = tslib_1.__values(values), values_12_1 = values_12.next(); !values_12_1.done; values_12_1 = values_12.next()) {
                    var value = values_12_1.value;
                    var key = keyof(value, ++index, values);
                    var group_1 = groups.get(key);
                    if (group_1)
                        group_1.push(value);
                    else
                        groups.set(key, [value]);
                }
            }
            catch (e_13_1) { e_13 = { error: e_13_1 }; }
            finally {
                try {
                    if (values_12_1 && !values_12_1.done && (_a = values_12.return)) _a.call(values_12);
                }
                finally { if (e_13) throw e_13.error; }
            }
            try {
                for (var groups_1 = tslib_1.__values(groups), groups_1_1 = groups_1.next(); !groups_1_1.done; groups_1_1 = groups_1.next()) {
                    var _c = tslib_1.__read(groups_1_1.value, 2), key = _c[0], values_13 = _c[1];
                    groups.set(key, regroup(values_13, i));
                }
            }
            catch (e_14_1) { e_14 = { error: e_14_1 }; }
            finally {
                try {
                    if (groups_1_1 && !groups_1_1.done && (_b = groups_1.return)) _b.call(groups_1);
                }
                finally { if (e_14) throw e_14.error; }
            }
            return map(groups);
        })(values, 0);
    }
    function permute(source, keys) {
        return Array.from(keys, function (key) { return source[key]; });
    }
    function sort(values) {
        var F = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            F[_i - 1] = arguments[_i];
        }
        if (typeof values[Symbol.iterator] !== "function")
            throw new TypeError("values is not iterable");
        values = Array.from(values);
        var _a = tslib_1.__read(F, 1), _b = _a[0], f = _b === void 0 ? ascending : _b;
        if (f.length === 1 || F.length > 1) {
            var index_6 = Uint32Array.from(values, function (d, i) { return i; });
            if (F.length > 1) {
                F = F.map(function (f) { return values.map(f); });
                index_6.sort(function (i, j) {
                    var e_15, _a;
                    try {
                        for (var F_1 = tslib_1.__values(F), F_1_1 = F_1.next(); !F_1_1.done; F_1_1 = F_1.next()) {
                            var f_1 = F_1_1.value;
                            var c = ascending(f_1[i], f_1[j]);
                            if (c)
                                return c;
                        }
                    }
                    catch (e_15_1) { e_15 = { error: e_15_1 }; }
                    finally {
                        try {
                            if (F_1_1 && !F_1_1.done && (_a = F_1.return)) _a.call(F_1);
                        }
                        finally { if (e_15) throw e_15.error; }
                    }
                });
            }
            else {
                f = values.map(f);
                index_6.sort(function (i, j) { return ascending(f[i], f[j]); });
            }
            return permute(values, index_6);
        }
        return values.sort(f);
    }
    function groupSort(values, reduce, key) {
        return (reduce.length === 1
            ? sort(rollup(values, reduce, key), (function (_a, _b) {
                var _c = tslib_1.__read(_a, 2), ak = _c[0], av = _c[1];
                var _d = tslib_1.__read(_b, 2), bk = _d[0], bv = _d[1];
                return ascending(av, bv) || ascending(ak, bk);
            }))
            : sort(group(values, key), (function (_a, _b) {
                var _c = tslib_1.__read(_a, 2), ak = _c[0], av = _c[1];
                var _d = tslib_1.__read(_b, 2), bk = _d[0], bv = _d[1];
                return reduce(av, bv) || ascending(ak, bk);
            })))
            .map(function (_a) {
            var _b = tslib_1.__read(_a, 1), key = _b[0];
            return key;
        });
    }
    var array = Array.prototype;
    var slice = array.slice;
    function constant(x) {
        return function () {
            return x;
        };
    }
    var e10 = Math.sqrt(50), e5 = Math.sqrt(10), e2 = Math.sqrt(2);
    function ticks(start, stop, count) {
        var reverse, i = -1, n, ticks, step;
        stop = +stop, start = +start, count = +count;
        if (start === stop && count > 0)
            return [start];
        if (reverse = stop < start)
            n = start, start = stop, stop = n;
        if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step))
            return [];
        if (step > 0) {
            start = Math.ceil(start / step);
            stop = Math.floor(stop / step);
            ticks = new Array(n = Math.ceil(stop - start + 1));
            while (++i < n)
                ticks[i] = (start + i) * step;
        }
        else {
            step = -step;
            start = Math.ceil(start * step);
            stop = Math.floor(stop * step);
            ticks = new Array(n = Math.ceil(stop - start + 1));
            while (++i < n)
                ticks[i] = (start + i) / step;
        }
        if (reverse)
            ticks.reverse();
        return ticks;
    }
    function tickIncrement(start, stop, count) {
        var step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log(step) / Math.LN10), error = step / Math.pow(10, power);
        return power >= 0
            ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power)
            : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
    }
    function tickStep(start, stop, count) {
        var step0 = Math.abs(stop - start) / Math.max(0, count), step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)), error = step0 / step1;
        if (error >= e10)
            step1 *= 10;
        else if (error >= e5)
            step1 *= 5;
        else if (error >= e2)
            step1 *= 2;
        return stop < start ? -step1 : step1;
    }
    function nice(start, stop, count) {
        var prestep;
        while (true) {
            var step = tickIncrement(start, stop, count);
            if (step === prestep || step === 0 || !isFinite(step)) {
                return [start, stop];
            }
            else if (step > 0) {
                start = Math.floor(start / step) * step;
                stop = Math.ceil(stop / step) * step;
            }
            else if (step < 0) {
                start = Math.ceil(start * step) / step;
                stop = Math.floor(stop * step) / step;
            }
            prestep = step;
        }
    }
    function sturges(values) {
        return Math.ceil(Math.log(count(values)) / Math.LN2) + 1;
    }
    function bin() {
        var value = identity, domain = extent, threshold = sturges;
        function histogram(data) {
            var _a;
            if (!Array.isArray(data))
                data = Array.from(data);
            var i, n = data.length, x, values = new Array(n);
            for (i = 0; i < n; ++i) {
                values[i] = value(data[i], i, data);
            }
            var xz = domain(values), x0 = xz[0], x1 = xz[1], tz = threshold(values, x0, x1);
            // Convert number of thresholds into uniform thresholds, and nice the
            // default domain accordingly.
            if (!Array.isArray(tz)) {
                var max_1 = x1, tn = +tz;
                if (domain === extent)
                    _a = tslib_1.__read(nice(x0, x1, tn), 2), x0 = _a[0], x1 = _a[1];
                tz = ticks(x0, x1, tn);
                // If the last threshold is coincident with the domain’s upper bound, the
                // last bin will be zero-width. If the default domain is used, and this
                // last threshold is coincident with the maximum input value, we can
                // extend the niced upper bound by one tick to ensure uniform bin widths;
                // otherwise, we simply remove the last threshold. Note that we don’t
                // coerce values or the domain to numbers, and thus must be careful to
                // compare order (>=) rather than strict equality (===)!
                if (tz[tz.length - 1] >= x1) {
                    if (max_1 >= x1 && domain === extent) {
                        var step = tickIncrement(x0, x1, tn);
                        if (isFinite(step)) {
                            if (step > 0) {
                                x1 = (Math.floor(x1 / step) + 1) * step;
                            }
                            else if (step < 0) {
                                x1 = (Math.ceil(x1 * -step) + 1) / -step;
                            }
                        }
                    }
                    else {
                        tz.pop();
                    }
                }
            }
            // Remove any thresholds outside the domain.
            var m = tz.length;
            while (tz[0] <= x0)
                tz.shift(), --m;
            while (tz[m - 1] > x1)
                tz.pop(), --m;
            var bins = new Array(m + 1), bin;
            // Initialize bins.
            for (i = 0; i <= m; ++i) {
                bin = bins[i] = [];
                bin.x0 = i > 0 ? tz[i - 1] : x0;
                bin.x1 = i < m ? tz[i] : x1;
            }
            // Assign data to bins by value, ignoring any outside the domain.
            for (i = 0; i < n; ++i) {
                x = values[i];
                if (x0 <= x && x <= x1) {
                    bins[bisectRight(tz, x, 0, m)].push(data[i]);
                }
            }
            return bins;
        }
        histogram.value = function (_) {
            return arguments.length ? (value = typeof _ === "function" ? _ : constant(_), histogram) : value;
        };
        histogram.domain = function (_) {
            return arguments.length ? (domain = typeof _ === "function" ? _ : constant([_[0], _[1]]), histogram) : domain;
        };
        histogram.thresholds = function (_) {
            return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? constant(slice.call(_)) : constant(_), histogram) : threshold;
        };
        return histogram;
    }
    function max(values, valueof) {
        var e_16, _a, e_17, _b;
        var max;
        if (valueof === undefined) {
            try {
                for (var values_14 = tslib_1.__values(values), values_14_1 = values_14.next(); !values_14_1.done; values_14_1 = values_14.next()) {
                    var value = values_14_1.value;
                    if (value != null
                        && (max < value || (max === undefined && value >= value))) {
                        max = value;
                    }
                }
            }
            catch (e_16_1) { e_16 = { error: e_16_1 }; }
            finally {
                try {
                    if (values_14_1 && !values_14_1.done && (_a = values_14.return)) _a.call(values_14);
                }
                finally { if (e_16) throw e_16.error; }
            }
        }
        else {
            var index_7 = -1;
            try {
                for (var values_15 = tslib_1.__values(values), values_15_1 = values_15.next(); !values_15_1.done; values_15_1 = values_15.next()) {
                    var value = values_15_1.value;
                    if ((value = valueof(value, ++index_7, values)) != null
                        && (max < value || (max === undefined && value >= value))) {
                        max = value;
                    }
                }
            }
            catch (e_17_1) { e_17 = { error: e_17_1 }; }
            finally {
                try {
                    if (values_15_1 && !values_15_1.done && (_b = values_15.return)) _b.call(values_15);
                }
                finally { if (e_17) throw e_17.error; }
            }
        }
        return max;
    }
    function min(values, valueof) {
        var e_18, _a, e_19, _b;
        var min;
        if (valueof === undefined) {
            try {
                for (var values_16 = tslib_1.__values(values), values_16_1 = values_16.next(); !values_16_1.done; values_16_1 = values_16.next()) {
                    var value = values_16_1.value;
                    if (value != null
                        && (min > value || (min === undefined && value >= value))) {
                        min = value;
                    }
                }
            }
            catch (e_18_1) { e_18 = { error: e_18_1 }; }
            finally {
                try {
                    if (values_16_1 && !values_16_1.done && (_a = values_16.return)) _a.call(values_16);
                }
                finally { if (e_18) throw e_18.error; }
            }
        }
        else {
            var index_8 = -1;
            try {
                for (var values_17 = tslib_1.__values(values), values_17_1 = values_17.next(); !values_17_1.done; values_17_1 = values_17.next()) {
                    var value = values_17_1.value;
                    if ((value = valueof(value, ++index_8, values)) != null
                        && (min > value || (min === undefined && value >= value))) {
                        min = value;
                    }
                }
            }
            catch (e_19_1) { e_19 = { error: e_19_1 }; }
            finally {
                try {
                    if (values_17_1 && !values_17_1.done && (_b = values_17.return)) _b.call(values_17);
                }
                finally { if (e_19) throw e_19.error; }
            }
        }
        return min;
    }
    // Based on https://github.com/mourner/quickselect
    // ISC license, Copyright 2018 Vladimir Agafonkin.
    function quickselect(array, k, left, right, compare) {
        if (left === void 0) { left = 0; }
        if (right === void 0) { right = array.length - 1; }
        if (compare === void 0) { compare = ascending; }
        while (right > left) {
            if (right - left > 600) {
                var n = right - left + 1;
                var m = k - left + 1;
                var z = Math.log(n);
                var s = 0.5 * Math.exp(2 * z / 3);
                var sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
                var newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
                var newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
                quickselect(array, k, newLeft, newRight, compare);
            }
            var t = array[k];
            var i = left;
            var j = right;
            swap(array, left, k);
            if (compare(array[right], t) > 0)
                swap(array, left, right);
            while (i < j) {
                swap(array, i, j), ++i, --j;
                while (compare(array[i], t) < 0)
                    ++i;
                while (compare(array[j], t) > 0)
                    --j;
            }
            if (compare(array[left], t) === 0)
                swap(array, left, j);
            else
                ++j, swap(array, j, right);
            if (j <= k)
                left = j + 1;
            if (k <= j)
                right = j - 1;
        }
        return array;
    }
    function swap(array, i, j) {
        var t = array[i];
        array[i] = array[j];
        array[j] = t;
    }
    function quantile(values, p, valueof) {
        values = Float64Array.from(numbers(values, valueof));
        if (!(n = values.length))
            return;
        if ((p = +p) <= 0 || n < 2)
            return min(values);
        if (p >= 1)
            return max(values);
        var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = max(quickselect(values, i0).subarray(0, i0 + 1)), value1 = min(values.subarray(i0 + 1));
        return value0 + (value1 - value0) * (i - i0);
    }
    function quantileSorted(values, p, valueof) {
        if (valueof === void 0) { valueof = number; }
        if (!(n = values.length))
            return;
        if ((p = +p) <= 0 || n < 2)
            return +valueof(values[0], 0, values);
        if (p >= 1)
            return +valueof(values[n - 1], n - 1, values);
        var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = +valueof(values[i0], i0, values), value1 = +valueof(values[i0 + 1], i0 + 1, values);
        return value0 + (value1 - value0) * (i - i0);
    }
    function freedmanDiaconis(values, min, max) {
        return Math.ceil((max - min) / (2 * (quantile(values, 0.75) - quantile(values, 0.25)) * Math.pow(count(values), -1 / 3)));
    }
    function scott(values, min, max) {
        return Math.ceil((max - min) / (3.5 * deviation(values) * Math.pow(count(values), -1 / 3)));
    }
    function maxIndex(values, valueof) {
        var e_20, _a, e_21, _b;
        var max;
        var maxIndex = -1;
        var index = -1;
        if (valueof === undefined) {
            try {
                for (var values_18 = tslib_1.__values(values), values_18_1 = values_18.next(); !values_18_1.done; values_18_1 = values_18.next()) {
                    var value = values_18_1.value;
                    ++index;
                    if (value != null
                        && (max < value || (max === undefined && value >= value))) {
                        max = value, maxIndex = index;
                    }
                }
            }
            catch (e_20_1) { e_20 = { error: e_20_1 }; }
            finally {
                try {
                    if (values_18_1 && !values_18_1.done && (_a = values_18.return)) _a.call(values_18);
                }
                finally { if (e_20) throw e_20.error; }
            }
        }
        else {
            try {
                for (var values_19 = tslib_1.__values(values), values_19_1 = values_19.next(); !values_19_1.done; values_19_1 = values_19.next()) {
                    var value = values_19_1.value;
                    if ((value = valueof(value, ++index, values)) != null
                        && (max < value || (max === undefined && value >= value))) {
                        max = value, maxIndex = index;
                    }
                }
            }
            catch (e_21_1) { e_21 = { error: e_21_1 }; }
            finally {
                try {
                    if (values_19_1 && !values_19_1.done && (_b = values_19.return)) _b.call(values_19);
                }
                finally { if (e_21) throw e_21.error; }
            }
        }
        return maxIndex;
    }
    function mean(values, valueof) {
        var e_22, _a, e_23, _b;
        var count = 0;
        var sum = 0;
        if (valueof === undefined) {
            try {
                for (var values_20 = tslib_1.__values(values), values_20_1 = values_20.next(); !values_20_1.done; values_20_1 = values_20.next()) {
                    var value = values_20_1.value;
                    if (value != null && (value = +value) >= value) {
                        ++count, sum += value;
                    }
                }
            }
            catch (e_22_1) { e_22 = { error: e_22_1 }; }
            finally {
                try {
                    if (values_20_1 && !values_20_1.done && (_a = values_20.return)) _a.call(values_20);
                }
                finally { if (e_22) throw e_22.error; }
            }
        }
        else {
            var index_9 = -1;
            try {
                for (var values_21 = tslib_1.__values(values), values_21_1 = values_21.next(); !values_21_1.done; values_21_1 = values_21.next()) {
                    var value = values_21_1.value;
                    if ((value = valueof(value, ++index_9, values)) != null && (value = +value) >= value) {
                        ++count, sum += value;
                    }
                }
            }
            catch (e_23_1) { e_23 = { error: e_23_1 }; }
            finally {
                try {
                    if (values_21_1 && !values_21_1.done && (_b = values_21.return)) _b.call(values_21);
                }
                finally { if (e_23) throw e_23.error; }
            }
        }
        if (count)
            return sum / count;
    }
    function median(values, valueof) {
        return quantile(values, 0.5, valueof);
    }
    function flatten(arrays) {
        var arrays_1, arrays_1_1, array_1, e_24_1;
        var e_24, _a;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 5, 6, 7]);
                    arrays_1 = tslib_1.__values(arrays), arrays_1_1 = arrays_1.next();
                    _b.label = 1;
                case 1:
                    if (!!arrays_1_1.done) return [3 /*break*/, 4];
                    array_1 = arrays_1_1.value;
                    return [5 /*yield**/, tslib_1.__values(array_1)];
                case 2:
                    _b.sent();
                    _b.label = 3;
                case 3:
                    arrays_1_1 = arrays_1.next();
                    return [3 /*break*/, 1];
                case 4: return [3 /*break*/, 7];
                case 5:
                    e_24_1 = _b.sent();
                    e_24 = { error: e_24_1 };
                    return [3 /*break*/, 7];
                case 6:
                    try {
                        if (arrays_1_1 && !arrays_1_1.done && (_a = arrays_1.return)) _a.call(arrays_1);
                    }
                    finally { if (e_24) throw e_24.error; }
                    return [7 /*endfinally*/];
                case 7: return [2 /*return*/];
            }
        });
    }
    function merge(arrays) {
        return Array.from(flatten(arrays));
    }
    function minIndex(values, valueof) {
        var e_25, _a, e_26, _b;
        var min;
        var minIndex = -1;
        var index = -1;
        if (valueof === undefined) {
            try {
                for (var values_22 = tslib_1.__values(values), values_22_1 = values_22.next(); !values_22_1.done; values_22_1 = values_22.next()) {
                    var value = values_22_1.value;
                    ++index;
                    if (value != null
                        && (min > value || (min === undefined && value >= value))) {
                        min = value, minIndex = index;
                    }
                }
            }
            catch (e_25_1) { e_25 = { error: e_25_1 }; }
            finally {
                try {
                    if (values_22_1 && !values_22_1.done && (_a = values_22.return)) _a.call(values_22);
                }
                finally { if (e_25) throw e_25.error; }
            }
        }
        else {
            try {
                for (var values_23 = tslib_1.__values(values), values_23_1 = values_23.next(); !values_23_1.done; values_23_1 = values_23.next()) {
                    var value = values_23_1.value;
                    if ((value = valueof(value, ++index, values)) != null
                        && (min > value || (min === undefined && value >= value))) {
                        min = value, minIndex = index;
                    }
                }
            }
            catch (e_26_1) { e_26 = { error: e_26_1 }; }
            finally {
                try {
                    if (values_23_1 && !values_23_1.done && (_b = values_23.return)) _b.call(values_23);
                }
                finally { if (e_26) throw e_26.error; }
            }
        }
        return minIndex;
    }
    function pairs(values, pairof) {
        var e_27, _a;
        if (pairof === void 0) { pairof = pair; }
        var pairs = [];
        var previous;
        var first = false;
        try {
            for (var values_24 = tslib_1.__values(values), values_24_1 = values_24.next(); !values_24_1.done; values_24_1 = values_24.next()) {
                var value = values_24_1.value;
                if (first)
                    pairs.push(pairof(previous, value));
                previous = value;
                first = true;
            }
        }
        catch (e_27_1) { e_27 = { error: e_27_1 }; }
        finally {
            try {
                if (values_24_1 && !values_24_1.done && (_a = values_24.return)) _a.call(values_24);
            }
            finally { if (e_27) throw e_27.error; }
        }
        return pairs;
    }
    function pair(a, b) {
        return [a, b];
    }
    function range(start, stop, step) {
        start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
        var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
        while (++i < n) {
            range[i] = start + i * step;
        }
        return range;
    }
    function least(values, compare) {
        var e_28, _a, e_29, _b;
        if (compare === void 0) { compare = ascending; }
        var min;
        var defined = false;
        if (compare.length === 1) {
            var minValue = void 0;
            try {
                for (var values_25 = tslib_1.__values(values), values_25_1 = values_25.next(); !values_25_1.done; values_25_1 = values_25.next()) {
                    var element = values_25_1.value;
                    var value = compare(element);
                    if (defined
                        ? ascending(value, minValue) < 0
                        : ascending(value, value) === 0) {
                        min = element;
                        minValue = value;
                        defined = true;
                    }
                }
            }
            catch (e_28_1) { e_28 = { error: e_28_1 }; }
            finally {
                try {
                    if (values_25_1 && !values_25_1.done && (_a = values_25.return)) _a.call(values_25);
                }
                finally { if (e_28) throw e_28.error; }
            }
        }
        else {
            try {
                for (var values_26 = tslib_1.__values(values), values_26_1 = values_26.next(); !values_26_1.done; values_26_1 = values_26.next()) {
                    var value = values_26_1.value;
                    if (defined
                        ? compare(value, min) < 0
                        : compare(value, value) === 0) {
                        min = value;
                        defined = true;
                    }
                }
            }
            catch (e_29_1) { e_29 = { error: e_29_1 }; }
            finally {
                try {
                    if (values_26_1 && !values_26_1.done && (_b = values_26.return)) _b.call(values_26);
                }
                finally { if (e_29) throw e_29.error; }
            }
        }
        return min;
    }
    function leastIndex(values, compare) {
        var e_30, _a;
        if (compare === void 0) { compare = ascending; }
        if (compare.length === 1)
            return minIndex(values, compare);
        var minValue;
        var min = -1;
        var index = -1;
        try {
            for (var values_27 = tslib_1.__values(values), values_27_1 = values_27.next(); !values_27_1.done; values_27_1 = values_27.next()) {
                var value = values_27_1.value;
                ++index;
                if (min < 0
                    ? compare(value, value) === 0
                    : compare(value, minValue) < 0) {
                    minValue = value;
                    min = index;
                }
            }
        }
        catch (e_30_1) { e_30 = { error: e_30_1 }; }
        finally {
            try {
                if (values_27_1 && !values_27_1.done && (_a = values_27.return)) _a.call(values_27);
            }
            finally { if (e_30) throw e_30.error; }
        }
        return min;
    }
    function greatest(values, compare) {
        var e_31, _a, e_32, _b;
        if (compare === void 0) { compare = ascending; }
        var max;
        var defined = false;
        if (compare.length === 1) {
            var maxValue = void 0;
            try {
                for (var values_28 = tslib_1.__values(values), values_28_1 = values_28.next(); !values_28_1.done; values_28_1 = values_28.next()) {
                    var element = values_28_1.value;
                    var value = compare(element);
                    if (defined
                        ? ascending(value, maxValue) > 0
                        : ascending(value, value) === 0) {
                        max = element;
                        maxValue = value;
                        defined = true;
                    }
                }
            }
            catch (e_31_1) { e_31 = { error: e_31_1 }; }
            finally {
                try {
                    if (values_28_1 && !values_28_1.done && (_a = values_28.return)) _a.call(values_28);
                }
                finally { if (e_31) throw e_31.error; }
            }
        }
        else {
            try {
                for (var values_29 = tslib_1.__values(values), values_29_1 = values_29.next(); !values_29_1.done; values_29_1 = values_29.next()) {
                    var value = values_29_1.value;
                    if (defined
                        ? compare(value, max) > 0
                        : compare(value, value) === 0) {
                        max = value;
                        defined = true;
                    }
                }
            }
            catch (e_32_1) { e_32 = { error: e_32_1 }; }
            finally {
                try {
                    if (values_29_1 && !values_29_1.done && (_b = values_29.return)) _b.call(values_29);
                }
                finally { if (e_32) throw e_32.error; }
            }
        }
        return max;
    }
    function greatestIndex(values, compare) {
        var e_33, _a;
        if (compare === void 0) { compare = ascending; }
        if (compare.length === 1)
            return maxIndex(values, compare);
        var maxValue;
        var max = -1;
        var index = -1;
        try {
            for (var values_30 = tslib_1.__values(values), values_30_1 = values_30.next(); !values_30_1.done; values_30_1 = values_30.next()) {
                var value = values_30_1.value;
                ++index;
                if (max < 0
                    ? compare(value, value) === 0
                    : compare(value, maxValue) > 0) {
                    maxValue = value;
                    max = index;
                }
            }
        }
        catch (e_33_1) { e_33 = { error: e_33_1 }; }
        finally {
            try {
                if (values_30_1 && !values_30_1.done && (_a = values_30.return)) _a.call(values_30);
            }
            finally { if (e_33) throw e_33.error; }
        }
        return max;
    }
    function scan(values, compare) {
        var index = leastIndex(values, compare);
        return index < 0 ? undefined : index;
    }
    var shuffle = shuffler(Math.random);
    function shuffler(random) {
        return function shuffle(array, i0, i1) {
            if (i0 === void 0) { i0 = 0; }
            if (i1 === void 0) { i1 = array.length; }
            var m = i1 - (i0 = +i0);
            while (m) {
                var i = random() * m-- | 0, t = array[m + i0];
                array[m + i0] = array[i + i0];
                array[i + i0] = t;
            }
            return array;
        };
    }
    function sum(values, valueof) {
        var e_34, _a, e_35, _b;
        var sum = 0;
        if (valueof === undefined) {
            try {
                for (var values_31 = tslib_1.__values(values), values_31_1 = values_31.next(); !values_31_1.done; values_31_1 = values_31.next()) {
                    var value = values_31_1.value;
                    if (value = +value) {
                        sum += value;
                    }
                }
            }
            catch (e_34_1) { e_34 = { error: e_34_1 }; }
            finally {
                try {
                    if (values_31_1 && !values_31_1.done && (_a = values_31.return)) _a.call(values_31);
                }
                finally { if (e_34) throw e_34.error; }
            }
        }
        else {
            var index_10 = -1;
            try {
                for (var values_32 = tslib_1.__values(values), values_32_1 = values_32.next(); !values_32_1.done; values_32_1 = values_32.next()) {
                    var value = values_32_1.value;
                    if (value = +valueof(value, ++index_10, values)) {
                        sum += value;
                    }
                }
            }
            catch (e_35_1) { e_35 = { error: e_35_1 }; }
            finally {
                try {
                    if (values_32_1 && !values_32_1.done && (_b = values_32.return)) _b.call(values_32);
                }
                finally { if (e_35) throw e_35.error; }
            }
        }
        return sum;
    }
    function transpose(matrix) {
        if (!(n = matrix.length))
            return [];
        for (var i = -1, m = min(matrix, length$1), transpose = new Array(m); ++i < m;) {
            for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n;) {
                row[j] = matrix[j][i];
            }
        }
        return transpose;
    }
    function length$1(d) {
        return d.length;
    }
    function zip() {
        return transpose(arguments);
    }
    function every(values, test) {
        var e_36, _a;
        if (typeof test !== "function")
            throw new TypeError("test is not a function");
        var index = -1;
        try {
            for (var values_33 = tslib_1.__values(values), values_33_1 = values_33.next(); !values_33_1.done; values_33_1 = values_33.next()) {
                var value = values_33_1.value;
                if (!test(value, ++index, values)) {
                    return false;
                }
            }
        }
        catch (e_36_1) { e_36 = { error: e_36_1 }; }
        finally {
            try {
                if (values_33_1 && !values_33_1.done && (_a = values_33.return)) _a.call(values_33);
            }
            finally { if (e_36) throw e_36.error; }
        }
        return true;
    }
    function some(values, test) {
        var e_37, _a;
        if (typeof test !== "function")
            throw new TypeError("test is not a function");
        var index = -1;
        try {
            for (var values_34 = tslib_1.__values(values), values_34_1 = values_34.next(); !values_34_1.done; values_34_1 = values_34.next()) {
                var value = values_34_1.value;
                if (test(value, ++index, values)) {
                    return true;
                }
            }
        }
        catch (e_37_1) { e_37 = { error: e_37_1 }; }
        finally {
            try {
                if (values_34_1 && !values_34_1.done && (_a = values_34.return)) _a.call(values_34);
            }
            finally { if (e_37) throw e_37.error; }
        }
        return false;
    }
    function filter(values, test) {
        var e_38, _a;
        if (typeof test !== "function")
            throw new TypeError("test is not a function");
        var array = [];
        var index = -1;
        try {
            for (var values_35 = tslib_1.__values(values), values_35_1 = values_35.next(); !values_35_1.done; values_35_1 = values_35.next()) {
                var value = values_35_1.value;
                if (test(value, ++index, values)) {
                    array.push(value);
                }
            }
        }
        catch (e_38_1) { e_38 = { error: e_38_1 }; }
        finally {
            try {
                if (values_35_1 && !values_35_1.done && (_a = values_35.return)) _a.call(values_35);
            }
            finally { if (e_38) throw e_38.error; }
        }
        return array;
    }
    function map(values, mapper) {
        if (typeof values[Symbol.iterator] !== "function")
            throw new TypeError("values is not iterable");
        if (typeof mapper !== "function")
            throw new TypeError("mapper is not a function");
        return Array.from(values, function (value, index) { return mapper(value, index, values); });
    }
    function reduce(values, reducer, value) {
        var _a, _b;
        if (typeof reducer !== "function")
            throw new TypeError("reducer is not a function");
        var iterator = values[Symbol.iterator]();
        var done, next, index = -1;
        if (arguments.length < 3) {
            (_a = iterator.next(), done = _a.done, value = _a.value);
            if (done)
                return;
            ++index;
        }
        while ((_b = iterator.next(), done = _b.done, next = _b.value, _b), !done) {
            value = reducer(value, next, ++index, values);
        }
        return value;
    }
    function reverse(values) {
        if (typeof values[Symbol.iterator] !== "function")
            throw new TypeError("values is not iterable");
        return Array.from(values).reverse();
    }
    function difference(values) {
        var e_39, _a, e_40, _b;
        var others = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            others[_i - 1] = arguments[_i];
        }
        values = new Set(values);
        try {
            for (var others_1 = tslib_1.__values(others), others_1_1 = others_1.next(); !others_1_1.done; others_1_1 = others_1.next()) {
                var other = others_1_1.value;
                try {
                    for (var other_1 = (e_40 = void 0, tslib_1.__values(other)), other_1_1 = other_1.next(); !other_1_1.done; other_1_1 = other_1.next()) {
                        var value = other_1_1.value;
                        values.delete(value);
                    }
                }
                catch (e_40_1) { e_40 = { error: e_40_1 }; }
                finally {
                    try {
                        if (other_1_1 && !other_1_1.done && (_b = other_1.return)) _b.call(other_1);
                    }
                    finally { if (e_40) throw e_40.error; }
                }
            }
        }
        catch (e_39_1) { e_39 = { error: e_39_1 }; }
        finally {
            try {
                if (others_1_1 && !others_1_1.done && (_a = others_1.return)) _a.call(others_1);
            }
            finally { if (e_39) throw e_39.error; }
        }
        return values;
    }
    function disjoint(values, other) {
        var e_41, _a, _b;
        var iterator = other[Symbol.iterator](), set = new Set();
        try {
            for (var values_36 = tslib_1.__values(values), values_36_1 = values_36.next(); !values_36_1.done; values_36_1 = values_36.next()) {
                var v = values_36_1.value;
                if (set.has(v))
                    return false;
                var value = void 0, done = void 0;
                while ((_b = iterator.next(), value = _b.value, done = _b.done, _b)) {
                    if (done)
                        break;
                    if (Object.is(v, value))
                        return false;
                    set.add(value);
                }
            }
        }
        catch (e_41_1) { e_41 = { error: e_41_1 }; }
        finally {
            try {
                if (values_36_1 && !values_36_1.done && (_a = values_36.return)) _a.call(values_36);
            }
            finally { if (e_41) throw e_41.error; }
        }
        return true;
    }
    function set(values) {
        return values instanceof Set ? values : new Set(values);
    }
    function intersection(values) {
        var e_42, _a, e_43, _b;
        var others = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            others[_i - 1] = arguments[_i];
        }
        values = new Set(values);
        others = others.map(set);
        try {
            out: for (var values_37 = tslib_1.__values(values), values_37_1 = values_37.next(); !values_37_1.done; values_37_1 = values_37.next()) {
                var value = values_37_1.value;
                try {
                    for (var others_2 = (e_43 = void 0, tslib_1.__values(others)), others_2_1 = others_2.next(); !others_2_1.done; others_2_1 = others_2.next()) {
                        var other = others_2_1.value;
                        if (!other.has(value)) {
                            values.delete(value);
                            continue out;
                        }
                    }
                }
                catch (e_43_1) { e_43 = { error: e_43_1 }; }
                finally {
                    try {
                        if (others_2_1 && !others_2_1.done && (_b = others_2.return)) _b.call(others_2);
                    }
                    finally { if (e_43) throw e_43.error; }
                }
            }
        }
        catch (e_42_1) { e_42 = { error: e_42_1 }; }
        finally {
            try {
                if (values_37_1 && !values_37_1.done && (_a = values_37.return)) _a.call(values_37);
            }
            finally { if (e_42) throw e_42.error; }
        }
        return values;
    }
    function superset(values, other) {
        var e_44, _a, _b;
        var iterator = values[Symbol.iterator](), set = new Set();
        try {
            for (var other_2 = tslib_1.__values(other), other_2_1 = other_2.next(); !other_2_1.done; other_2_1 = other_2.next()) {
                var o = other_2_1.value;
                if (set.has(o))
                    continue;
                var value = void 0, done = void 0;
                while ((_b = iterator.next(), value = _b.value, done = _b.done, _b)) {
                    if (done)
                        return false;
                    set.add(value);
                    if (Object.is(o, value))
                        break;
                }
            }
        }
        catch (e_44_1) { e_44 = { error: e_44_1 }; }
        finally {
            try {
                if (other_2_1 && !other_2_1.done && (_a = other_2.return)) _a.call(other_2);
            }
            finally { if (e_44) throw e_44.error; }
        }
        return true;
    }
    function subset(values, other) {
        return superset(other, values);
    }
    function union() {
        var e_45, _a, e_46, _b;
        var others = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            others[_i] = arguments[_i];
        }
        var set = new Set();
        try {
            for (var others_3 = tslib_1.__values(others), others_3_1 = others_3.next(); !others_3_1.done; others_3_1 = others_3.next()) {
                var other = others_3_1.value;
                try {
                    for (var other_3 = (e_46 = void 0, tslib_1.__values(other)), other_3_1 = other_3.next(); !other_3_1.done; other_3_1 = other_3.next()) {
                        var o = other_3_1.value;
                        set.add(o);
                    }
                }
                catch (e_46_1) { e_46 = { error: e_46_1 }; }
                finally {
                    try {
                        if (other_3_1 && !other_3_1.done && (_b = other_3.return)) _b.call(other_3);
                    }
                    finally { if (e_46) throw e_46.error; }
                }
            }
        }
        catch (e_45_1) { e_45 = { error: e_45_1 }; }
        finally {
            try {
                if (others_3_1 && !others_3_1.done && (_a = others_3.return)) _a.call(others_3);
            }
            finally { if (e_45) throw e_45.error; }
        }
        return set;
    }
    exports.Adder = Adder;
    exports.InternMap = InternMap;
    exports.InternSet = InternSet;
    exports.ascending = ascending;
    exports.bin = bin;
    exports.bisect = bisectRight;
    exports.bisectCenter = bisectCenter;
    exports.bisectLeft = bisectLeft;
    exports.bisectRight = bisectRight;
    exports.bisector = bisector;
    exports.count = count;
    exports.cross = cross;
    exports.cumsum = cumsum;
    exports.descending = descending;
    exports.deviation = deviation;
    exports.difference = difference;
    exports.disjoint = disjoint;
    exports.every = every;
    exports.extent = extent;
    exports.filter = filter;
    exports.fsum = fsum;
    exports.greatest = greatest;
    exports.greatestIndex = greatestIndex;
    exports.group = group;
    exports.groupSort = groupSort;
    exports.groups = groups;
    exports.histogram = bin;
    exports.index = index;
    exports.indexes = indexes;
    exports.intersection = intersection;
    exports.least = least;
    exports.leastIndex = leastIndex;
    exports.map = map;
    exports.max = max;
    exports.maxIndex = maxIndex;
    exports.mean = mean;
    exports.median = median;
    exports.merge = merge;
    exports.min = min;
    exports.minIndex = minIndex;
    exports.nice = nice;
    exports.pairs = pairs;
    exports.permute = permute;
    exports.quantile = quantile;
    exports.quantileSorted = quantileSorted;
    exports.quickselect = quickselect;
    exports.range = range;
    exports.reduce = reduce;
    exports.reverse = reverse;
    exports.rollup = rollup;
    exports.rollups = rollups;
    exports.scan = scan;
    exports.shuffle = shuffle;
    exports.shuffler = shuffler;
    exports.some = some;
    exports.sort = sort;
    exports.subset = subset;
    exports.sum = sum;
    exports.superset = superset;
    exports.thresholdFreedmanDiaconis = freedmanDiaconis;
    exports.thresholdScott = scott;
    exports.thresholdSturges = sturges;
    exports.tickIncrement = tickIncrement;
    exports.tickStep = tickStep;
    exports.ticks = ticks;
    exports.transpose = transpose;
    exports.union = union;
    exports.variance = variance;
    exports.zip = zip;
    Object.defineProperty(exports, '__esModule', { value: true });
})));
